import { Component, ViewChild, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ExplanationService } from './examination/explanation.service';
import { saveAs } from 'file-saver/FileSaver';
import { environment } from 'environments/environment';
import { AuthService } from './auth.service';
import { DownloadService } from './download.service';
import { MatSidenav } from '@angular/material';
import { Subject } from 'rxjs';
import { SignlaterService, SignLater } from './signlater.service';
import { SemsoEncryptionModule } from 'app/encryption/encryption.module';
import { Router } from '@angular/router';
import { BreadcrumbService } from './breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private laterTeOndertekenen: SignLater[] = [];
  public url: object;
  private pageNumber = 0;
  private index: 0;

  @ViewChild('sidenav') sidenav: MatSidenav;

  private destroy$ = new Subject();

  constructor(
    private explanationService: ExplanationService,
    private workprocessDownloadService: DownloadService,
    public authService: AuthService,
    private signlaterService: SignlaterService,
    private encryption: SemsoEncryptionModule,
    private router: Router,
    private breadcrumbService: BreadcrumbService) { }

  ngOnInit(): void {
    this.index = 0;
    if (environment.production) {
      if (location.protocol === 'http:') {
        window.location.href = location.href.replace('http', 'https');
      }
    }

    this.signlaterService.change.subscribe(() => {
      this.loadBatchOndertekenen();
    });

    this.signlaterService.next.subscribe(() => {
      this.signlaterService.getSignLater().subscribe(data => {
        this.laterTeOndertekenen = data;
        this.index++;
        this.batchOndertekenen();
      });
    });

    this.signlaterService.nextAfterSign.subscribe(() => {
      this.signlaterService.getSignLater().subscribe(data => {
        this.laterTeOndertekenen = data;
        if (this.index > 0) {
          this.index--;
        }
        this.batchOndertekenen();
      });
    });
  }

  loadBatchOndertekenen() {
    this.signlaterService.getSignLater().subscribe(data => {
      this.laterTeOndertekenen = data;
    });
  }

  initBatchOndertekenen() {
    this.index = 0;
    this.batchOndertekenen();
  }

  batchOndertekenen() {
    if (this.laterTeOndertekenen.length > 0 && this.index < this.laterTeOndertekenen.length) {
      var data = this.laterTeOndertekenen[this.index];
      this.breadcrumbService.studentName = "";
      this.breadcrumbService.coreTaskCode = "";
      this.breadcrumbService.workProcessCode = "";
      if (data.type.toLowerCase() == "opdracht") {
        this.router.navigate(['examination-preparation', this.encryption.encrypt(data.studentnummer), data.creboCode, 'assignment-pvb', data.id, 'signing', 'company', 'batch'], { queryParamsHandling: 'merge' });
      } else {
        this.router.navigate(['students', this.encryption.encrypt(data.studentnummer), data.creboCode, 'crebos', 'examination', data.id, 'result', 'second-assessor-signing', 'batch'], { queryParamsHandling: 'merge' });
      }
    } else {
      this.router.navigate(['/students'], { queryParamsHandling: 'merge' });
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  ngAfterViewInit(): void {
    this.explanationService.openExplanation$.subscribe(pagenumber => {
      this.pageNumber = pagenumber;
      this.sidenav.open();
    });

    this.explanationService.setExplanationSource$.subscribe(url => {
      setTimeout(() => {
        this.url = {
          url: url,
          httpHeaders: {
            Authorization: `Bearer ${this.authService.getToken()}`
          }
        }
      });
    });

    this.sidenav.closedStart
      .takeUntil(this.destroy$)
      .subscribe(() => {
        this.pageNumber = 0;
        this.url = null;
      })

    this.workprocessDownloadService.pdf$.subscribe(data => {
      saveAs(data.data, data.name);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts